export default __webpack_public_path__ + "static/media/area-lead-nc.1aacb9f9.svg";